export default {
  SERVER_URL: process.env.VUE_APP_URL,
  AW_URL: process.env.VUE_APP_AW_URL,
  APP_API_URL: process.env.VUE_APP_API_URL
}
